// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Iran from '../_raw/flag/icon_flag_iran.png';

export default () => <img src={Iran} alt="Iran" />;
